// Projetos do veículo. `projectIds` é a lista de projetos atendidos; `projectId` permanece como projeto principal
// para retrocompatibilidade (cadastros antigos só possuem `projectId`).
export const MAX_PROJECT_LINKS = 20;

type ProjectLinked = { projectId?: unknown; projectIds?: unknown; [key: string]: unknown } | null | undefined;

export function vehicleProjectIds(record: ProjectLinked): string[] {
  if (!record) return [];
  const list = Array.isArray(record.projectIds) ? record.projectIds.map(String).filter(Boolean) : [];
  const primary = typeof record.projectId === "string" && record.projectId ? record.projectId : "";
  return [...new Set(list.length ? list : primary ? [primary] : [])];
}

export function isInProject(record: ProjectLinked, projectId: string): boolean {
  return vehicleProjectIds(record).includes(projectId);
}

/** Normaliza a entrada: o projeto principal é `projectId` quando também está selecionado; senão, o primeiro da lista. */
export function normalizeProjectLinks(projectId: unknown, projectIds: unknown): { projectId: string; projectIds: string[] } | null {
  const list = [...new Set((Array.isArray(projectIds) ? projectIds : []).map((id) => String(id ?? "").trim()).filter(Boolean))];
  const primary = typeof projectId === "string" ? projectId.trim() : "";
  const selected = list.length ? list : primary ? [primary] : [];
  if (!selected.length) return null;
  const main = primary && selected.includes(primary) ? primary : selected[0];
  return { projectId: main, projectIds: [main, ...selected.filter((id) => id !== main)] };
}

/**
 * Projetos em que o veículo está baixado. A baixa vale por projeto: baixar no projeto X não afeta os demais.
 * Cadastros antigos não têm o campo: `active: false` (sem baixa por empresa registrada) significava baixado em todos os projetos.
 */
export function inactiveProjectIds(record: ProjectLinked): string[] {
  const links = vehicleProjectIds(record);
  if (record && Array.isArray(record.inactiveProjectIds)) return [...new Set(record.inactiveProjectIds.map(String).filter((id) => links.includes(id)))];
  return record?.active === false && !Array.isArray(record.inactiveCompanyIds) ? links : [];
}

/** O veículo atende o projeto e não está baixado nele. */
export function isActiveInProject(record: ProjectLinked, projectId: string | null | undefined): boolean {
  return Boolean(projectId) && vehicleProjectIds(record).includes(String(projectId)) && !inactiveProjectIds(record).includes(String(projectId));
}
